import { TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { useQueryClient } from "react-query"
import useStyles from "./styles"

const AutocompleteInput = ({ group, context, setContext }) => {
  const classes = useStyles()
  const queryClient = useQueryClient()
  const [autocompleteValue, setAutocompleteValue] = useState("")
  const [textValue, setTextValue] = useState("")

  return (
    <Autocomplete
      options={group || []}
      renderInput={(params) => <TextField {...params} variant="filled" />}
      value={autocompleteValue}
      onChange={(e, val) => {
        setAutocompleteValue(val)
      }}
      getOptionLabel={(option) => option.name || option}
      getOptionDisabled={(option) =>
        !!context.find((y) => y.name === option.name)
      }
      freeSolo
      openOnFocus
      onInputChange={(e, val) => {
        setTextValue(val)
      }}
      inputValue={textValue}
      style={{
        width: "100%",
        backgroundColor: "#F4F4F4",
        borderRadius: "4px",
      }}
      onKeyPress={(e) => {
        if (
          e.key === "Enter" &&
          (textValue !== "" || autocompleteValue !== "")
        ) {
          //check if we are using the same work with capital letters or spaces
          if (
            group.find(
              (y) =>
                y.name.replace(/\s+/g, "").toLowerCase() ===
                textValue.replace(/\s+/g, "").toLowerCase(),
            ) &&
            context.find(
              (y) =>
                y.name.replace(/\s+/g, "").toLowerCase() ===
                textValue.replace(/\s+/g, "").toLowerCase(),
            )
          ) {
            // upon finding a match in input tag vs existing tag
            setAutocompleteValue("")
            setTextValue("")
          } else {
            const found = group.find(
              (y) =>
                y.name.replace(/\s+/g, "").toLowerCase() ===
                textValue.replace(/\s+/g, "").toLowerCase(),
            )
            if (found) {
              setContext([...context, found])
              setAutocompleteValue("")
              setTextValue("")
            } else {
              setAutocompleteValue("")
              setTextValue("")
              setContext([
                ...context,
                typeof autocompleteValue === "object"
                  ? autocompleteValue
                  : { name: autocompleteValue },
              ])
            }
          }
        }
      }}
      size="small"
      classes={{
        inputRoot: classes.autocompleteRoot,
      }}
    />
  )
}
AutocompleteInput.propTypes = {
  context: PropTypes.array,
  group: PropTypes.array,
  autocompleteValue: PropTypes.string,
  textValue: PropTypes.string,
  setContext: PropTypes.func,
  setAutocompleteValue: PropTypes.func,
  setTextValue: PropTypes.func,
}
export default AutocompleteInput
